// extracted by mini-css-extract-plugin
export default {"CVView":"CVView_CVView__0dpxv","row":"CVView_row__FStMN"};